export default "__VITE_ASSET__11af28c6__"